import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";

interface SortParticipantsProps {
  onClickSort: (isAscending: boolean) => void;
}
export const SortParticipants = ({ onClickSort }: SortParticipantsProps) => {
  const [isAscending, setIsAscending] = useState(false);

  const handleClick = () => {
    setIsAscending(!isAscending);
    onClickSort(isAscending);
  };

  return (
    <div className="grid grid-cols-2 pr-2 font-medium text-gray-800">
      <p className="pr-1">{t("live_streams.dashboard.participants.sort")}</p>
      <Icon
        type="caret-down"
        className={classNames("cursor-pointer fill-gray-800", {
          "rotate-180": isAscending,
        })}
        onClick={handleClick}
      />
    </div>
  );
};
